const img = require('./Sides.svg'); export default img;